import dayjs from 'dayjs';

export const GOOGLE_ANALYTICS_ID_PROD = 'G-3C57FNQETF';
export const GOOGLE_ANALYTICS_ID_DEV = 'G-PYM7SBGB3J';

export const BookingRange = {
  start: dayjs('20230601', 'YYYYMMDD').startOf('day'),
  end: dayjs('20230910', 'YYYYMMDD').endOf('day'),
};

export const RequestStatus = {
  FailedCancellation: 'FailedCancellation',
  SuccessfulCancellation: 'SuccessfulCancellation',
  UnSuccessfulPayment: 'UnSuccessfulPayment',
  FailedPackageCancellation: 'FailedPackageCancellation',
  SuccessfulPackageCancellation: 'SuccessfulPackageCancellation',
};

export const VoucherErrors = {
  DURATION: 'DURATION',
  INVALID_VOUCHER: 'INVALID_VOUCHER',
};

export const TimeUnits = {
  SESSION: 'session',
  HOUR: 'hour',
};

export const SESSION_DURATION = 15;

export const DEFAULT_CURRENCY = 'AED';

export const DEFAULT_MAX_QUANTITY = 6;

export const STATUS_MESSAGES: Map<string, string> = new Map([
  [
    RequestStatus.FailedCancellation,
    'Booking cannot be cancelled because the booking start time is after the cancellation policy limit.',
  ],
  [
    RequestStatus.SuccessfulCancellation,
    'Your booking is cancelled and a refund to your original mode of payment is being processed. Refunds can take 7-14 working days to reflect in your account .',
  ],
  [
    RequestStatus.UnSuccessfulPayment,
    'Unfortunately we were not able to process your payment. Please try again.',
  ],
  [RequestStatus.FailedPackageCancellation, 'Package cannot be cancelled once used.'],
]);

export enum RegistrationStep {
  SignUp = 'SignUp',
  Login = 'Login',
  CompleteProfile = 'CompleteProfile',
}

export const ROUTES_WITHOUT_CART_ICON = ['/confirmation', '/cancellation', '/packageconfirmation' , '/offers'];

export const DSW_COMPANY_ID = 'RLa9ofEY89ZEiMQgCFsc';

export const WINTER_CAMP_COMPANY_ID = 'a83015bb1d544ebd96c526742e199d54';

export const DUBAI_FITNESS_CHALLENGE_COMPANY_ID = 'c932bf3ec1fb4c49b0865fe8cc600ec7';

export const DFC_SCHOOL_EXPERIENCE_COMPANY_ID = '7e445521d82f4989b63f72c2b6e0e0f6';

export const DANUBE_SPORTS_WORLD_COMPANY_ID = '5ec87dccb71c410bb4ff449d0ebb4d34';

export const REAL_SPORTS_CLUB_COMPANY_ID = '94b835de17c14fb4ac74bd31cdcc252c';

export const COME_N_PLAY_COMPANY_ID = 'FI8KHXe7EKtHIC9XCvaf';

export const BEIRUT_MARATHON_COMPANY_ID = '1e155a15055a411885597917746c1787';

export const FOILHUB_DUBAI_COMPANY_ID = '8ef64c9eb1c6427d8279621fa7b22e15';

export const SPORTS_DISTRICT_COMPANY_ID = 'c4661f5f4257496896290b7e7621fd72';

export const WAKEUP_WATERSPORTS_COMPANY_ID = 'tJ7CPKw6SI0kQXQTYrrn';

// export const DANUBE_SPORTS_WORLD_COMPANY_ID = 'be0a55ecf3844df8a683a62c85bec69e';

export const BaseUrlToCompany = new Map([
  ['https://staging.dubaisportsworld.ae', DSW_COMPANY_ID],
  ['https://booking.dubaisportsworld.ae', DSW_COMPANY_ID],
  ['https://booking.dubaifitnesschallenge.com', DUBAI_FITNESS_CHALLENGE_COMPANY_ID],
  ['https://educationprogramme.dubaifitnesschallenge.com', DFC_SCHOOL_EXPERIENCE_COMPANY_ID],
  ['https://booking.danubesportsworld.com', DANUBE_SPORTS_WORLD_COMPANY_ID],
  ['https://booking.realsportsclub.com', REAL_SPORTS_CLUB_COMPANY_ID],
  ['https://comenplay.ae', COME_N_PLAY_COMPANY_ID],
  ['https://booking.comenplay.ae', COME_N_PLAY_COMPANY_ID],
  ['https://www.realsports.club', REAL_SPORTS_CLUB_COMPANY_ID],
  ['https://realsports.club', REAL_SPORTS_CLUB_COMPANY_ID],
  ['https://bookings.sportsdistrict.sa', SPORTS_DISTRICT_COMPANY_ID],
]);



export const DEFAULT_DURATION_MULTIPLES = 15;